/**
 * @desc 根据条件获取受益部门列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.RevenueDepartmentResponseDto>>;
export function request(
  body: defs.basics.RevenueDepartmentRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/revenueDepartment/getRevenueDepartmentList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
